import { render, staticRenderFns } from "./addVendorPersonalDetailComponent.vue?vue&type=template&id=286cdea1&"
import script from "./addVendorPersonalDetailComponent.vue?vue&type=script&lang=js&"
export * from "./addVendorPersonalDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports